export const formFieldStyles = {
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#F9FAFB",
    borderRadius: "6px",
    "& fieldset": {
      borderColor: "rgba(74, 85, 101, 0.10)",
      padding: "2px",
    },
    "&:hover fieldset": {
      borderColor: "rgba(74, 85, 101, 0.10)",
      padding: "2px",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#005EFF",
      padding: "2px",
    },
  },
  "& .MuiFormHelperText-root": {
    marginLeft: 0,
  },
  "& .MuiInputBase-input": {
    fontSize: "14px",
    padding: "8px",
  },
  "& .MuiSelect-select": {
    fontSize: "14px",
    padding: "8px",
  },
  "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
    {
      WebkitAppearance: "none",
      margin: 0,
    },
  "& input[type=number]": {
    MozAppearance: "textfield",
  },
};

export const searchStyles = {
  borderRadius: "6px",
  opacity: "0.7",
  width: "20rem",
  "& .MuiOutlinedInput-root": {
    height: "40px",
    borderRadius: "12px",
    bgcolor: "background.default",
    "&:hover fieldset": { borderColor: "grey.100" },
    "&.Mui-focused fieldset": { borderColor: "grey.100" },
  },
};

export const dialogTitleStyles = {
  color: "#000814",
  fontSize: "20px",
  fontWeight: 600,
  lineHeight: "18px",
  letterSpacing: "-0.439px",
};

export const dialogDescriptionStyles = {
  color: "#61708A",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "-0.15px",
  mt: 0.5,
};

export const labelStyles = {
  fontSize: "14px",
  fontWeight: 500,
  display: "block",
};
